import { DealerLocationID } from "./DealerLocation";

export type TyreTeamCredentialID = number;

export enum TYRETEAM_CHANNELS {
  WheelTyre = 1,
  BandenExpress = 2
}

export interface TyreTeamCredential {
  id: TyreTeamCredentialID; // Claire TyreTeamCredential ID
  channel: TYRETEAM_CHANNELS; // Channel used for TyreTeam Queries
  login: string; // Login used for TyreTeam Authorization
  password: string; // Password used for TyreTeam Authorization
  location_id: string; // Location ID provided by TyreTeam
  customer_id: string; // Customer ID provided by TyreTeam
  dealer_location_id: DealerLocationID; // Claire location ID using these credentials
}
